import { useState, useEffect, useRef } from "react"
import { Lock, Star, Crown, ChevronLeft, ChevronRight, Check } from "lucide-react"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"
import { getPassport, getProfile } from "../api"

const skipMotion = () =>
  typeof window !== "undefined" &&
  (navigator.webdriver ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches);

const BattlePass = () => {
  const [currentPage, setCurrentPage] = useState(0) // Reset to start from first page
  const [userLevel, setUserLevel] = useState(1)
  const [userStars, setUserStars] = useState(0)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [selectedReward, setSelectedReward] = useState(null)
  const [isMobile, setIsMobile] = useState(false)
  const root = useRef(null)

  const rewardsPerPage = isMobile ? 5 : 10 // 5 on mobile, 10 on desktop
  const maxLevel = 50

  // Check if user is logged in and fetch their data
  useEffect(() => {
    // Check screen size for responsive rewards per page
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640) // 640px is Tailwind's 'sm' breakpoint
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    // Real auth: Discord session via the backend, then live level/RP from MongoDB
    const checkUserAuth = async () => {
      try {
        const pass = await getPassport()
        if (!pass || !pass.user || pass.user.id === 'NOPASS') return
        const profile = await getProfile(pass.user.id)
        if (!profile || profile.error) return
        setIsLoggedIn(true)
        setUserLevel(profile.level || 0)
        setUserStars(profile.balancerp || 0)
      } catch (error) {
        console.error('Failed to fetch user progress:', error)
      }
    }

    checkUserAuth()

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const rewards = [
    { id: 1, type: "profile", name: "The Sketch", rarity: "common", level: 1, locked: userLevel < 1, image: "https://i.postimg.cc/Px5ZjF6x/season-2-level1.png" },
    { id: 2, type: "currency", name: "RP Reward", rarity: "common", level: 2, locked: userLevel < 2, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 3, type: "profile", name: "Propoganda", rarity: "common", level: 3, locked: userLevel < 3, image: "https://i.postimg.cc/fLP3hWt2/season-2-level3.png" },
    { id: 4, type: "currency", name: "RP Reward", rarity: "common", level: 4, locked: userLevel < 4, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 5, type: "profile", name: "Claydon anniversary", rarity: "rare", level: 5, locked: userLevel < 5, image: "https://i.postimg.cc/xqDccsPL/seson-2-level5.png" },
    { id: 6, type: "currency", name: "RP Reward", rarity: "common", level: 6, locked: userLevel < 6, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 7, type: "currency", name: "RP Reward", rarity: "common", level: 7, locked: userLevel < 7, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 8, type: "currency", name: "RP Reward", rarity: "common", level: 9, locked: userLevel < 9, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 9, type: "currency", name: "RP Reward", rarity: "common", level: 9, locked: userLevel < 9, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 10, type: "profile", name: "THE BOSS ", rarity: "rare", level: 10, locked: userLevel < 10, image: "https://i.postimg.cc/xdtJt30S/season-2-level10.png" },
    { id: 11, type: "currency", name: "RP Reward", rarity: "common", level: 11, locked: userLevel < 11, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 12, type: "profile", name: "Time for Victory", rarity: "rare", level: 12, locked: userLevel < 12, image: "https://i.postimg.cc/9F79C9BG/seson-2-level12.png" },
    { id: 13, type: "currency", name: "Thunder Rank Display", rarity: "epic", level: 13, locked: userLevel < 13, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 14, type: "currency", name: "RP Reward", rarity: "common", level: 14, locked: userLevel < 14, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 15, type: "profile", name: "Kaminari AD", rarity: "rare", level: 15, locked: userLevel < 15, image: "https://i.postimg.cc/jqGXHtg4/season-2-level15.png" },
    { id: 16, type: "Badge", name: "Takoyaki Badge", rarity: "rare", level: 16, locked: userLevel < 16, image: "https://i.postimg.cc/RFg7Jz3K/season-2-level16.png" },
    { id: 17, type: "currency", name: "RP Reward", rarity: "common", level: 17, locked: userLevel < 17, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 18, type: "profile", name: "The Thinker", rarity: "rare", level: 18, locked: userLevel < 18, image: "https://i.postimg.cc/0QXS2d3C/season-2-level18.png" },
    { id: 19, type: "rank", name: "City", rarity: "rare", level: 19, locked: userLevel < 19, image: "https://i.postimg.cc/Z566FNBT/season-2-level19.png" },
    { id: 20, type: "profile", name: "Man vs steel", rarity: "epic", level: 20, locked: userLevel < 20, image: "https://i.postimg.cc/kMVsRBc5/season-2-level20.png" },
    { id: 21, type: "currency", name: "RP Reward", rarity: "common", level: 21, locked: userLevel < 21, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 22, type: "currency", name: "RP Reward", rarity: "common", level: 21, locked: userLevel < 21, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 23, type: "profile", name: "The Forgotten", rarity: "epic", level: 23, locked: userLevel < 23, image: "https://i.postimg.cc/qq9C2Bph/season-2-level23.png" },
    { id: 24, type: "currency", name: "RP Reward", rarity: "common", level: 24, locked: userLevel < 24, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 25, type: "profile", name: "Mist awakening", rarity: "epic", level: 25, locked: userLevel < 25, image: "https://i.postimg.cc/y8KyGnzJ/season2-level25.png" },
    { id: 26, type: "currency", name: "RP Reward", rarity: "common", level: 26, locked: userLevel < 26, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 27, type: "currency", name: "RP Rewards", rarity: "epic", level: 27, locked: userLevel < 27, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 28, type: "profile", name: "Matthew 17:20", rarity: "epic", level: 28, locked: userLevel < 28, image: "https://i.postimg.cc/HL25FC9R/season-2-level28.png" },
    { id: 29, type: "currency", name: "RP Reward", rarity: "common", level: 29, locked: userLevel < 29, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 30, type: "profile", name: "Merry Christmas", rarity: "legendary", level: 30, locked: userLevel < 30, image: "https://i.postimg.cc/4yhY4CpJ/season-2-level30.png" },
    { id: 31, type: "currency", name: "RP Reward", rarity: "common", level: 31, locked: userLevel < 31, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 32, type: "currency", name: "RP Reward", rarity: "common", level: 32, locked: userLevel < 32, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 33, type: "profile", name: "Early Bird", rarity: "legendary", level: 33, locked: userLevel < 33, image: "https://i.postimg.cc/rszSSYWb/season-2-level33.gif" },
    { id: 34, type: "currency", name: "RP Reward", rarity: "common", level: 34, locked: userLevel < 34, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 35, type: "profile", name: "Dream Walk", rarity: "legendary", level: 35, locked: userLevel < 35, image: "https://i.postimg.cc/bJy0vvvq/season-2-level35.gif" },
    { id: 36, type: "rank", name: "Takoyaki Madness", rarity: "legendary", level: 36, locked: userLevel < 36, image: "https://i.postimg.cc/Yq51WRSn/season-2-level36.png" },
    { id: 37, type: "profile", name: "A saviour is born", rarity: "legendary", level: 37, locked: userLevel < 37, image: "https://i.postimg.cc/yx50nXyN/season-2-level37.png" },
    { id: 38, type: "currency", name: "RP Reward", rarity: "common", level: 38, locked: userLevel < 38, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 39, type: "currency", name: "RP Reward", rarity: "common", level: 39, locked: userLevel < 39, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 40, type: "profile", name: "Kaminari airlines", rarity: "legendary", level: 40, locked: userLevel < 40, image: "https://i.postimg.cc/Y904VL9L/season2-level-40.png" },
    { id: 41, type: "currency", name: "RP Reward", rarity: "common", level: 41, locked: userLevel < 41, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 42, type: "currency", name: "RP Reward", rarity: "common", level: 42, locked: userLevel < 42, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 43, type: "profile", name: "Old Footage", rarity: "legendary", level: 43, locked: userLevel < 43, image: "https://i.postimg.cc/52zS7GGW/season-2-level43.gif" },
    { id: 44, type: "currency", name: "RP Reward", rarity: "common", level: 44, locked: userLevel < 44, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 45, type: "profile", name: "Happy New Year", rarity: "legendary", level: 45, locked: userLevel < 45, image: "https://i.postimg.cc/CMt837bh/season-2-level45.gif" },
    { id: 46, type: "currency", name: "RP Reward", rarity: "common", level: 46, locked: userLevel < 46, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 47, type: "currency", name: "RP Reward", rarity: "common", level: 47, locked: userLevel < 47, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 48, type: "currency", name: "RP Reward", rarity: "common", level: 47, locked: userLevel < 47, image: "https://i.postimg.cc/g2y66PQj/RP.png" },
    { id: 49, type: "rank", name: "Investigation", rarity: "legendary", level: 49, locked: userLevel < 49, image: "https://i.postimg.cc/SKp7wdF2/season-2-level49.gif" },
    { id: 50, type: "profile", name: "Bike Ride", rarity: "legendary", level: 50, locked: userLevel < 50, image: "https://i.postimg.cc/KjKMK3hh/season-2-level50.gif" },
  ]

  // Navigation functions
  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const goToNextPage = () => {
    const totalPages = Math.ceil(rewards.length / rewardsPerPage)
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1)
    }
  }

  const getCurrentPageRewards = () => {
    const startIndex = currentPage * rewardsPerPage
    const endIndex = startIndex + rewardsPerPage
    return rewards.slice(startIndex, endIndex)
  }

  // Rarity styling: border / glow / label colors per tier
  const RARITY = {
    common: {
      border: "border-slate-400/40",
      glow: "shadow-[0_0_18px_rgba(148,163,184,0.15)]",
      text: "text-slate-300",
      chip: "bg-slate-500/20 border-slate-400/40 text-slate-200",
      beam: "from-slate-400/20",
    },
    rare: {
      border: "border-sky-400/60",
      glow: "shadow-[0_0_22px_rgba(56,189,248,0.3)]",
      text: "text-sky-300",
      chip: "bg-sky-500/20 border-sky-400/50 text-sky-200",
      beam: "from-sky-400/25",
    },
    epic: {
      border: "border-purple-400/60",
      glow: "shadow-[0_0_22px_rgba(192,132,252,0.35)]",
      text: "text-purple-300",
      chip: "bg-purple-500/20 border-purple-400/50 text-purple-200",
      beam: "from-purple-400/25",
    },
    legendary: {
      border: "border-amber-400/70",
      glow: "shadow-[0_0_26px_rgba(251,191,36,0.4)]",
      text: "text-amber-300",
      chip: "bg-amber-500/20 border-amber-400/50 text-amber-200",
      beam: "from-amber-400/30",
    },
  }
  const rarityOf = (r) => RARITY[r] || RARITY.common

  // Entrance + page-flip animations
  useGSAP(() => {
    if (skipMotion()) return;
    gsap.from("[data-bp-header]", { y: -30, opacity: 0, duration: 0.7, ease: "power3.out" })
    gsap.from("[data-bp-showcase]", { x: -40, opacity: 0, duration: 0.8, delay: 0.15, ease: "power3.out" })
  }, { scope: root })

  useGSAP(() => {
    if (skipMotion()) return;
    gsap.fromTo(
      "[data-bp-tier]",
      { y: 26, opacity: 0, scale: 0.94 },
      { y: 0, opacity: 1, scale: 1, duration: 0.45, stagger: 0.05, ease: "back.out(1.6)" }
    )
  }, { scope: root, dependencies: [currentPage, isMobile] })

  const showcase = selectedReward || rewards.find(r => r.level === 50)
  const totalPages = Math.ceil(rewards.length / rewardsPerPage)
  const nextReward = rewards.find(r => r.level > userLevel)

  return (
    <div ref={root} className="relative min-h-screen overflow-hidden flex flex-col">
      {/* ===== Cinematic backdrop ===== */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://i.postimg.cc/6pxv3QHF/BPbg.png"
          alt=""
          loading="lazy"
          decoding="async"
          fetchpriority="low"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-void via-void/80 to-void/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-void via-transparent to-void/80" />
      </div>
      <div className="absolute top-1/4 -right-32 w-[36rem] h-[36rem] rounded-full bg-gradient-radial from-amber-500/10 to-transparent blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-[90rem] mx-auto w-full px-4 sm:px-6 lg:px-10 py-8 sm:py-10 flex flex-col flex-grow">

        {/* ===== Top bar: season + activation badge ===== */}
        <div data-bp-header className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-8 sm:mb-12">
          <div className="flex items-center gap-4">
            <h1 className="font-Bebas text-4xl sm:text-5xl text-white tracking-wider">
              BATTLE <span className="text-amber-300">PASS</span>
            </h1>
            <div className="hidden sm:block w-px h-10 bg-white/15" />
            <p className="hidden sm:block font-poppins text-xs tracking-[0.3em] uppercase text-white/40">
              Season 2 · Kaminari Cooperation
            </p>
          </div>

          {isLoggedIn ? (
            <div className="text-right">
              <div className="inline-block bg-amber-400 text-black font-Bebas tracking-widest text-sm sm:text-base px-4 py-1">
                BATTLE PASS ACTIVATED
              </div>
              <div className="block bg-black/70 border border-amber-400/40 font-Bebas tracking-widest text-amber-300 text-xs sm:text-sm px-4 py-1 mt-1">
                CURRENT TIER: {userLevel}
              </div>
            </div>
          ) : (
            <a
              href="/auth/discord"
              className="bg-amber-400 hover:bg-amber-300 text-black font-Bebas tracking-widest text-sm sm:text-base px-5 py-2 transition-colors duration-200"
            >
              LOGIN TO TRACK PROGRESS
            </a>
          )}
        </div>

        {/* ===== Showcase: info left, art right (Warzone style) ===== */}
        <div data-bp-showcase className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center flex-grow mb-8 sm:mb-12">
          <div className="text-center lg:text-left order-2 lg:order-1">
            <p className={`font-poppins text-xs sm:text-sm tracking-[0.25em] uppercase mb-3 ${showcase ? rarityOf(showcase.rarity).text : "text-amber-300"}`}>
              ◆ {showcase ? showcase.rarity : "legendary"} — {showcase ? showcase.type : "profile"} reward
            </p>
            <h2 className="font-Bebas text-6xl sm:text-7xl lg:text-8xl text-white tracking-wide leading-[0.9] mb-4">
              {showcase ? showcase.name.toUpperCase() : "BIKE RIDE"}
            </h2>
            <div className="inline-flex items-center gap-2 bg-black/60 border border-white/15 px-4 py-2 mb-6">
              <span className="font-Bebas tracking-widest text-white/80 text-sm sm:text-base">
                {showcase && !showcase.locked ? "✓ UNLOCKED" : `UNLOCKS AT TIER ${showcase ? showcase.level : 50}`}
              </span>
            </div>

            {/* Player stats strip */}
            {isLoggedIn && (
              <div className="flex items-center justify-center lg:justify-start gap-6 font-Bebas tracking-wider text-white/90">
                <span className="flex items-center gap-2">
                  <Crown className="w-5 h-5 text-amber-400" /> LVL {userLevel}
                </span>
                <span className="flex items-center gap-2">
                  <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" /> {userStars.toLocaleString()} RP
                </span>
                {nextReward && (
                  <span className="text-white/40 font-poppins text-xs tracking-normal normal-case">
                    next reward at tier {nextReward.level}
                  </span>
                )}
              </div>
            )}
            {!isLoggedIn && (
              <p className="font-poppins text-white/45 text-sm max-w-md mx-auto lg:mx-0">
                Chat in Discord to earn XP — every tier unlocks profile cards,
                rank skins, badges and RP. Select a tier below to preview it.
              </p>
            )}
          </div>

          {/* Reward art — big, floating, rarity glow */}
          <div className="relative flex items-center justify-center order-1 lg:order-2">
            <div className={`absolute w-80 h-80 rounded-full blur-3xl bg-gradient-radial ${showcase ? rarityOf(showcase.rarity).beam : "from-amber-400/30"} to-transparent opacity-70 pointer-events-none`} />
            <img
              key={showcase ? showcase.id : "default"}
              src={showcase ? showcase.image : "https://i.postimg.cc/KjKMK3hh/season-2-level50.gif"}
              alt={showcase ? showcase.name : "Bike Ride"}
              decoding="async"
              className="relative max-h-[280px] sm:max-h-[380px] lg:max-h-[44vh] object-contain animate-floaty drop-shadow-[0_20px_50px_rgba(0,0,0,0.6)]"
            />
          </div>
        </div>

        {/* ===== Bottom tier track (Warzone strip) ===== */}
        <div className="mt-auto">
          <div className="flex items-end gap-2 sm:gap-3">
            <button
              onClick={goToPreviousPage}
              disabled={currentPage === 0}
              aria-label="Previous page"
              className={`flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 mb-6 border transition-all duration-200 ${
                currentPage === 0
                  ? 'border-white/10 text-white/20 cursor-not-allowed'
                  : 'border-amber-400/50 text-amber-300 hover:bg-amber-400/10 hover:scale-110'
              }`}
            >
              <ChevronLeft className="w-6 h-6" />
            </button>

            <div className="flex-grow grid grid-cols-5 lg:grid-cols-10 gap-1.5 sm:gap-2">
              {getCurrentPageRewards().map((reward) => {
                const r = rarityOf(reward.rarity)
                const isSelected = selectedReward?.id === reward.id
                return (
                  <div key={reward.id} className="flex flex-col">
                    <button
                      data-bp-tier
                      onClick={() => setSelectedReward(reward)}
                      style={{ aspectRatio: '1 / 1' }}
                      className={`relative w-full border-2 ${reward.locked ? 'border-white/15' : 'border-amber-400/80'} ${reward.locked ? "" : r.glow} bg-black/60 overflow-hidden group cursor-pointer transition-all duration-300 hover:scale-105 hover:-translate-y-1 ${
                        isSelected ? "ring-2 ring-white scale-105 -translate-y-1" : ""
                      }`}
                    >
                      <img
                        src={reward.image || "/placeholder.svg"}
                        alt={reward.name}
                        loading="lazy"
                        decoding="async"
                        className={`absolute inset-0 w-full h-full object-cover transition-all duration-300 ${
                          reward.locked ? "grayscale brightness-[0.45]" : "group-hover:scale-110"
                        }`}
                      />
                      <div className={`absolute top-0 inset-x-0 h-1/3 bg-gradient-to-b ${r.beam} to-transparent pointer-events-none`} />

                      {reward.locked ? (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <Lock className="w-4 h-4 sm:w-5 sm:h-5 text-white/70" />
                        </div>
                      ) : (
                        <div className="absolute top-1 right-1 flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 bg-amber-400 border border-black/30">
                          <Check className="w-3 h-3 text-black" />
                        </div>
                      )}
                    </button>

                    {/* Warzone-style tier plate + progress segment */}
                    <div className={`mt-1 py-0.5 text-center font-Bebas text-xs sm:text-sm tracking-widest ${
                      reward.locked ? 'bg-white/5 text-white/40' : 'bg-amber-400 text-black'
                    }`}>
                      {reward.level}
                    </div>
                    <div className="mt-1 h-1 bg-white/10">
                      <div
                        className="h-full bg-gradient-to-r from-amber-500 to-amber-300 transition-all duration-700"
                        style={{ width: reward.locked ? '0%' : '100%' }}
                      />
                    </div>
                  </div>
                )
              })}
            </div>

            <button
              onClick={goToNextPage}
              disabled={currentPage >= totalPages - 1}
              aria-label="Next page"
              className={`flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 mb-6 border transition-all duration-200 ${
                currentPage >= totalPages - 1
                  ? 'border-white/10 text-white/20 cursor-not-allowed'
                  : 'border-amber-400/50 text-amber-300 hover:bg-amber-400/10 hover:scale-110'
              }`}
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>

          <p className="text-center font-Bebas tracking-[0.3em] text-white/30 text-sm mt-3">
            TIERS {(currentPage * rewardsPerPage) + 1} – {Math.min((currentPage + 1) * rewardsPerPage, rewards.length)} OF {rewards.length} · PAGE {currentPage + 1}/{totalPages}
          </p>
        </div>
      </div>
    </div>
  )
}

export default BattlePass
